<template>
	<div>
		<div v-if="!submitted" class="row">
			<div class="col-md-6 my-auto">
				<div class="watch-demo-image-wrapper">
					<div class="overlay"></div>
					<img src="/img/webinar.png" alt="Infinity"
						class="w-100">
					<div class="register-to-watch">
						<img @click="checkForm" src="/img/home-v2/playbtn.svg" alt="" class="pulse-button" width="50px"
							style="filter: drop-shadow(0px 15px 50px rgba(34, 34, 34, 0.35));">
						<h3 class="lp-demo__preview-video-title mt-3">Register to watch</h3>
						<!-- <span class="lp-demo__preview-video-arrow d-none d-lg-block ml-auto mr-2"></span> -->
					</div>
				</div>
			</div>
			<div class="col-md-6 my-4 my-md-auto">
				<div class="secret-with-text mx-auto p-4"
					style="z-index: 1;">
					<div class="form-wrapper">
						<form @submit.prevent="checkForm">
							<div class="input-wrapper mb-4">
								<!-- <label for="name-sub">Name *</label> -->
								<input type="text" v-model="form.name" required placeholder="Enter your name *" id="name-sub">
								<div class="text-danger text-left" v-if="errors.name" v-text="errors.name"></div>
							</div>
							<div class="input-wrapper mb-4">
								<!-- <label for="email-sub">Email *</label> -->
								<input type="email" v-model="form.email" required placeholder="Enter your email *" class="subscribe-email" id="email-sub">
								<div class="text-danger text-left" v-if="errors.email" v-text="errors.email"></div>
							</div>
							<div class="input-wrapper mb-4">
								<!-- <label for="name-sub">Job Title *</label> -->
								<input type="text" v-model="form.jobTitle" required placeholder="Enter your job title *" id="name-sub">
								<div class="text-danger text-left" v-if="errors.jobTitle" v-text="errors.jobTitle"></div>
							</div>
							<div class="form-group">
								<div id="dropdown" class="dropdown">
									<button type="button" id="dropdownButton" class="dropdownButton" data-flip="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<span v-if="form.industry.name === null" style="color: #989898;">
											Select Industy *
										</span>
										<span v-else>
											{{form.industry.name}}
										</span>
									</button>
									<div class="dropdown-menu" aria-labelledby="dropdownButton">
										<div
											v-for="industry in industries"
											:key="industry.id"
											@click="form.industry = industry"
											:class="{ 'active' : industry.id === form.industry.id }"
											class="dropdown-item">
											{{industry.name}}
										</div>
									</div>
								</div>
								<div v-if="errors && errors.industry" class="text-danger text-left">{{ errors.industry}}</div>

							</div>
							<br>
							<button type="submit" :disabled="busy" class="cta-btn-v2 sub-submit m-auto">Submit and watch
								<div v-if="busy" class="lds-ring ml-2"><div></div><div></div><div></div><div></div></div>
							</button>
							<p>
								We value your privacy, and we'll never misuse private information that you entrust us with.
							</p>
						</form>
					</div>
					<img src="/img/managing-clients-funnel/right_shadow.png" alt="Infinity"
						class="shadow-right">
				</div>
			</div>

		</div>
		<div v-else>
			<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative; width: 100%; z-index: 2;">
				<div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
					<div class="wistia_embed wistia_async_pd7fet1h1c videoFoam=true" style="height:100%;position:relative;width:100%">
						<div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">
							<img src="https://fast.wistia.com/embed/medias/pd7fet1h1c/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="less" scoped>
.lds-ring {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.watch-demo-image-wrapper {
	max-width: 100%;
	overflow: hidden;
	border-radius: 8px;
	position: relative;
	.overlay {
		background: rgba(24, 31, 56, .8);
		box-shadow: inset -10px 0 30px #00000040;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}
	.register-to-watch {
		width: 100%;
		position: absolute;
		top: 0;
		z-index: 2;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 100%;
		h3 {
			color: #fff;
			font-size: 32px;
		}
	}
}
.dropdown {
		.dropdownButton {
			// appearance: none;
			width: 100%;
			height: 50px;
			border: 1px solid #DFDFDF;
			background-color: #fff;
			border-radius: 6px;
			color: #120C32;
			padding: 15px 18px;
			font-size: 16px;
			background-image: url('/img/pricing/dropdown-arrow-down.svg');
			background-repeat: no-repeat;
			background-size: 15px 9px;
			background-position: 95% 50%;
			text-align: left;
			display: flex;
			align-items: center;
			&:focus, &:active {
				border: 1px solid #BFB6FF;
				outline: none;
			}
		}
		.dropdown-menu {
			z-index: 10;
			max-height: 300px;
			overflow-y: scroll;
			width: 100%;
			background: #FFFFFF;
			box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.25);
			border-radius: 6px;
			padding: 7px;
			&::-webkit-scrollbar {
				border-radius: 10px;
				width: 8px;
				background-color: #F5F5F5;
			}
			&::-webkit-scrollbar-thumb {
				border-radius: 10px;
				background-color: #62647b36;
			}
			.dropdown-item {
				cursor: pointer;
				border-radius: 6px;
				font-size: 16px;
				&:hover {
					background-color: #F6F4FF;
				}
			}
			.dropdown-item.active {
				background-color: transparent;
				color: #5946CF;
				background-image: url('/img/pricing/ic-check.svg');
				background-repeat: no-repeat;
				background-size: 15px 9px;
				background-position: 95% 50%;
				text-align: left;
			}
		}
	}

	.form-wrapper{

		background: #FAFBFC;
		height:auto;
		width:470px;
		background-size: 100% 100%;
		text-align:center;
		position:relative;
		display:inline !important;
		z-index:4;
		border-radius:20px;
	}
	@media (max-width: 650px) {
		.form-wrapper{
			width:90%;
		}
	}
	.form-wrapper h3{
		font-size: 25px;
	}
	.form-wrapper p{
		font-size: 18px;
		line-height: 21px;
		text-align: center;
		color: #120C32;
		margin:0 auto;
		margin-bottom:50px;
		max-width:500px;
		margin-bottom: 0 !important;
	}

	.form-wrapper .sub-submit{
		border: none;
		margin-bottom:30px !important;
	}
	.form-wrapper p{
		font-weight: 500;
		font-size: 14px;
		line-height: 19px;
		text-align: center;

		color: rgba(18, 12, 50, 0.56);
	}
	.form-wrapper label{
		display: block;
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #120C32;
		text-align: left;
	}
	.form-wrapper input{
		/* border: 1px solid #FFFFFF; */
		background: #FFFFFF;
		border: 1px solid #DFDFDF;
		box-sizing: border-box;
		border-radius: 6px;
		font-size: 18px;
		line-height: 25px;
		width:100%;
		height: 50px;
		padding-left:18px;
	}
	.form-wrapper .sub-progress{
		height:100px;
		width:100%;
		background:white;
		padding: 25px 40px;
	}
	@media (max-width: 650px) {
		.form-wrapper .sub-progress{
			padding: 25px 20px;
		}
	}
	.form-wrapper .sub-progress-text{
		font-size: 14px;
		line-height: 19px;
		text-align: center;
		color: #000000;
		margin-bottom:11px;
	}


	.form-wrapper ::-webkit-input-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}
	.form-wrapper ::-moz-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}
	.form-wrapper :-ms-input-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}
	.form-wrapper :-moz-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}
</style>
<script type="application/javascript">
import axios from 'axios';

export default {
    data() {
        return {
            errorName: null,
            errorEmail: null,
            form: {
                name: null,
                email: null,
                jobTitle: null,
                industry: {
                    id: null,
                    name: null
                }
            },
            errors: {},
            busy: false,
            industries: [
                {
                    id:'64efcdad-b50b-4479-ad0e-2f762f642616',
                    name:'Marketing',
                },
                {
                    id:'a0effff1-fe8a-4fbc-aa74-e0bc6603fa34',
                    name:'Sales',
                },
                {
                    id:'6da24221-5b4d-4a92-a82a-ee1b70cd5fab',
                    name:'IT',
                },
                {
                    id:'06e82b9e-e712-4200-a969-6df9300f8f6c',
                    name:'Finance',
                },
                {
                    id:'82479963-465e-477b-9347-635c8c373fa8',
                    name:'Education',
                },
                {
                    id:'342f8fe1-4469-4111-8f7b-63cad8303630',
                    name:'Legal',
                },
                {
                    id:'128c31ac-8766-4b9c-aa1a-482327f3a682',
                    name:'HR',
                },
                {
                    id:'2685689e-1663-4bf1-b714-721ad2786b7f',
                    name:'Retail',
                },
                {
                    id:'6f9b88a2-61e7-4240-84bd-9a9895ee953f',
                    name:'Healthcare',
                },
                {
                    id:'69c0956c-156d-469c-aa4d-933643e1d7cc',
                    name:'Gaming',
                },
                {
                    id:'2cd03343-31f0-484b-9633-eee1e19964b1',
                    name:'Government',
                },
                {
                    id:'0ec76568-638e-44a0-8065-08ace3cef1e2',
                    name:'Art & Design',
                },
                {
                    id:'d4e1c506-6886-4b73-8ea9-239fd4f090fe',
                    name:'Tourism',
                },
                {
                    id:'9b9fb4a5-bbdb-4814-9e6f-ac46c14c37e9',
                    name:'Real Estate',
                },
                {
                    id:'510ce2c5-8e44-4cb8-9573-53e746abe3fc',
                    name:'Consumer Goods',
                },
                {
                    id:'5f2019de-568b-454f-a381-1caed76ec6d5',
                    name:'Non-Profit',
                },
                {
                    id:'07d2d208-cf65-41cc-b50a-963a3092dd0c',
                    name:'Other',
                }
            ],

            submitted: false,
        };
    },
    methods:{
        checkForm() {
            this.busy = true;
            this.errors = {};

            if (!this.form.name) {
                this.errors.name = 'Name is required.';
            }
            if (this.form.name && this.form.name.length < 3) {
                this.errors.neme = 'Name must be at least 2 character.';
            }

            if (!this.form.email) {
                this.errors.email = 'Email is required.';
            }

            if (!this.form.jobTitle) {
                this.errors.jobTitle = 'Job title is required';
            }

            if (!this.form.industry.name) {
                this.errors.industry = 'Industry is required';
            }

            if(Object.keys(this.errors).length === 0 && !this.submitted){
                axios.post('/watch-demo-leads', this.form).then(() => {
                    dataLayer.push({
                        event: 'watch_demo_leads',
                    });

                    window.Intercom('boot', {
                        app_id: 'ujmidnoy',
                        email: this.form.email,
                        name: this.form.name,
                        webinar_industry: this.form.industry.name,
                        webinar_job_title: this.form.jobTitle,

                        watch_demo_leads: true, // custom attribute ( property )
                        user_id: this.form.email ,
                        created_at:  Math.round((new Date()).getTime() / 1000),
                    });

                    axios.put('/api/analytics', {
                        'name': 'watch_demo_leads',
                    });

                    // add to cookie
                    this.$cookies.set('watch_demo_submitted', true ,60 * 60 * 24 * 30* 12 );
                    this.$cookies.set('email', this.email ,60 * 60 * 24 * 30* 12 );
                    this.$cookies.set('name', this.name ,60 * 60 * 24 * 30* 12 );
                    this.submitted = true;
                    this.busy = false;
                }).catch(error => {
                    if(error.response.status === 429) {
                        this.tooMany = error.response.data.message;
                    }
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors || {};
                    }
                    this.busy = false;
                });
            } else {
                this.busy = false;
            }
        }
    },
    mounted() {
        this.submitted =  this.$cookies.isKey('watch_demo_submitted');
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/SubscribeWebinar.vue